import React, { useContext, useEffect, useRef, useState} from "react";
import {useNavigate} from 'react-router';
import NoteItem from "./NoteItem";
import noteContext from "../context/notes/noteContext";
import '../App.css';
import SearchBar from "./Searchbar";
const Notes = (props) => {

const{showAlert} = props;
let navigate = useNavigate();

  const context = useContext(noteContext);
  const { notes, getNotes, editNote} = context;
  useEffect(() => {
    
  if(localStorage.getItem('token')){
     getNotes();
  }
  else{
  navigate("/login")
  }
   // eslint-disable-next-line
  }, [])

  const ref = useRef(null)
   const refClose = useRef(null)
  const [note, setNote] = useState({id:"", etitle:"", edescription:"", etag:""})
  const updateNote =(currentNote)=>{
ref.current.click();
setNote({id: currentNote._id, etitle: currentNote.title, etag: currentNote.tag, edescription: currentNote.description})
  }

const handleClick=(e) =>{
    e.preventDefault();
   editNote(note.id, note.etitle, note.edescription, note.etag)
   refClose.current.click();
   showAlert({type:"info", title:"Update:", message:"Note updated successfully."});
}

const onChange=(e)=>{
   setNote({...note, [e.target.name]: e.target.value}) 
}

const [searchTerm, setSearchTerm] = useState("");

// filter notes by title or description
const filteredNotes = notes.filter((note) =>
 ( note.title||"").toLowerCase().includes(searchTerm.toLowerCase()) ||
  (note.tag||"").toLowerCase().includes(searchTerm.toLowerCase())
);

  return (
 <>
<button ref={ref} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Launch demo modal
</button>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content" style={{ backgroundColor: "#f8f9fa", borderRadius: "20px" }}>
      <div className="modal-header">
        <h1 className="modal-title fs-5" id="exampleModalLabel">Edit Note</h1>
        {/* Close button if you want to add:
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        */}
      </div>

      <div className="modal-body">
        <form className="row g-3">
          <div className="col-md-6">
            <label htmlFor="title" className="form-label">Title</label>
            <input
              type="text"
              className="form-control custom-textarea"
              id="etitle"
              name="etitle"
              value={note.etitle}
              onChange={onChange}
              minLength={3}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="tag" className="form-label">Tag</label>
            <input
              type="text"
              className="form-control custom-textarea"
              id="etag"
              name="etag"
              value={note.etag}
              onChange={onChange}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="description" className="form-label">Description</label>
            <textarea
              className="form-control custom-textarea"
              id="edescription"
              name="edescription"
              value={note.edescription}
              rows="5"
              onChange={onChange}
              minLength={5}
              required
            ></textarea>
          </div>
        </form>
      </div>
      <div className="modal-footer">
        <button type="button"   style={{
                       backgroundColor: 'rgb(243, 244, 246)',
    color: '#6b7280',
    border: 'none',
    borderRadius: '8px',
    padding: '7px 14px',
    fontSize: '12px',
    cursor: 'pointer',
    transition: 'background-color 0.2s', 
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#e5e7eb")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#f3f4f6")}
               ref ={refClose} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
       <button
  type="button"
  style={{
    backgroundColor: "#eab308",
    color: "white",
    textDecoration: "none",
    padding: "7px 14px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "500",
    transition: "background-color 0.2s",
    border: "none",          // removes visible border
    outline: "none",         // removes focus outline
  }}
  onClick={handleClick}
  onMouseOver={(e) => (e.target.style.backgroundColor = "#d97706")}
  onMouseOut={(e) => (e.target.style.backgroundColor = "#eab308")}
>
  Update Note
</button>
      </div>
    </div>
  </div>
</div>
  <div style={{ marginTop: "30px", marginLeftt:"2rem" }}>
  <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
</div>
      <div className="row" style={{ display: 'flex', alignItem:"center", flexWrap: 'wrap', columnGap: '100px', rowGap:"0px", marginTop:"10px" }}>
    {filteredNotes.length === 0 ? (
       <div
          style={{
            gridColumn: "1 / -1",
            textAlign: "center",
            padding: "48px 24px",
            color: "#6b7280",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>📝</div>
          <h3 style={{ fontSize: "18px", fontWeight: "500", margin: "0 0 8px 0" }}>
            {searchTerm ? "No notes found" : "No notes yet"}
          </h3>
          <p style={{ margin: 0 }}>
            {searchTerm ? "Try adjusting your search terms" : "Create your first note to get started!"}
          </p>
        </div>
    ) : (
      filteredNotes.map((note) => (
        <NoteItem key={note._id} updateNote={updateNote} note={note} showAlert={showAlert} />
      ))
    )}
  </div>
    </>
  );
};

export default Notes;
